import React from 'react';
// Proceedings book Sales Follow up
const NineteenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>
      <p>
        We are excited to announce that the <strong>Proceedings Book</strong> for{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        has been finalized, and <strong>only a few slots remain</strong> for additional
        registrations. This is a unique opportunity for you to have your
        groundbreaking research featured in this highly anticipated publication,
        gaining exposure to a wider academic and professional audience.
      </p>

      <p>
        <strong>Why You Should Register Now:</strong>
        <ul>
          <li>
            <strong>Prestige & Recognition </strong>: Being included in the
            conference proceedings is an excellent way to showcase your research
            in a globally recognized platform.
          </li>

          <li>
            <strong>Wider Reach</strong>: The book will be distributed to key
            industry leaders, researchers, and academic institutions, maximizing
            visibility for your work.
          </li>
          <li>
            <strong>Limited Availability</strong>: With only a handful of spots
            left, this is your chance to be part of an exclusive group of
            contributors.
          </li>
        </ul>
      </p>

      <p>
        <strong>Don’t miss out on this incredible opportunity!</strong> Register now to secure
        your place and ensure that your research is part of this distinguished
        publication:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            Click Here
          </a>
        ) : (
          `[Click Here]`
        )}
        .
      </p>

      <p>
        We look forward to featuring your important contributions in the
        proceedings book.
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default NineteenStepTemplate;
